// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2sYom","rootSmall":"AddTileButton_rootSmall__2IeCi"};